import { Routes } from '@angular/router';
import { authGuard } from './login/auth.guard';
import { auctionGuard } from './auction/auction.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./login/login.routes').then(m => m.LOGIN_ROUTES)
  },
  {
    path: 'lots',
    loadChildren: () => import('./lots/lots.routes').then(m => m.LOTS_ROUTES),
    canActivate: [auctionGuard]
  },
  {
    path: 'room',
    loadChildren: () => import('./room/room.routes').then(m => m.ROOM_ROUTES),
    canActivate: [authGuard]
  },
  {
    path: 'auction',
    loadChildren: () => import('./auction/auction.routes').then(m => m.AUCTION_ROUTES),
    canActivate: [authGuard]
  },
  {
    path: 'no-event',
    loadChildren: () => import('./without-event/without-event.routes').then(m => m.WITHOUT_EVENT_ROUTES),
    canActivate: [authGuard]
  },
  { path: '**', redirectTo: '/login', pathMatch: 'full' }
]; 